
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/affiliates",
      function () {
        return require("private-next-pages/admin/affiliates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/affiliates"])
      });
    }
  